import { computed } from 'vue'

import i18n from '@/libs/i18n'

const { t } = i18n.global

export const PredefinedText = computed(() => {
    return {
        ErrorLoadData: t('errors.load_data'),
        ErrorOnAdd: t('errors.on_add'),
        ErrorOnEdit: t('errors.on_edit'),
        ErrorOnDelete: t('errors.on_delete'),
        ErrorOnSort: t('errors.on_sort'),
        ErrorOnUploadImage: t('errors.on_upload_image'),
        ErrorOnUploadFile: t('errors.on_upload_file'),
        ErrorOnPublish: t('errors.on_publish'),
        ErrorOnApprove: t('errors.on_approve'),
        ErrorOnDownload: t('errors.on_download'),
        AddSuccess: t('success.on_add'),
        EditSuccess: t('success.on_edit'),
        SortSuccess: t('success.on_sort'),
        DeleteSuccess: t('success.on_delete'),
        PublishSuccess: t('success.on_publish'),
        ApproveSuccess: t('success.on_approve'),
        DeleteRow: t('confirmations.delete_row'),
        DeactivateRow: t('confirmations.deactivate_row'),
        UsernameTaken: t('errors.user_exist'),
        ChannelPackageActivated: t('success.channel_package_activated'),
        ChannelPackageDeactivated: t('success.channel_package_deactivated'),
        DeleteKey: t('confirmations.header'),
        ConfirmPublish: t('confirmations.publish'),
        ConfirmApprove: t('confirmations.approve')
    }
})

export enum FilterTypes {
    Text = 1,
    Number,
    Date,
    Select,
    MultiSelect,
    Boolean
}

// The three periods work on a task can fall in. They are billing tariffs, so the values have
// to stay in step with the API's WorkPeriod package - which is also what suggests them, see
// getSuggestedWorkPeriod in @/utils/task.ts.
export enum WorkPeriod {
    // What a task logged before the field existed comes back as, and what "nobody said" looks
    // like on the wire - never an option to pick, see workPeriodOptions in @/utils/task.ts.
    NotSet = '',
    WorkingHours = 'working_hours',
    OutsideWorkingHours = 'outside_working_hours',
    WeekendOrHoliday = 'weekend_or_holiday'
}

export enum BasicOverviewType {
    Custom = 1,
    Text,
    Boolean,
    Date,
    TextWithColor,
    Sensitive
}
